<style scoped>
.card_shadow {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 8px 8px 23px #b9b9b9, -8px -8px 23px #ffffff !important;
}

.btn_shadow {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 10px #838383, -4px -4px 10px #ffffff !important;
}

.headline {
  background-color: #1b2643;
  height: 60px;
}

.headline-rounded {
  border-radius: 3px;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.active_text {
  border-bottom: 2px solid #ffffff;
  height: 60px;
}

.headline p {
  color: #ffffff;
  font-size: 14px;
}

td {
  border-bottom: 1px solid #dbdbdb;
}
</style>

<template>
  <div>
    <div v-show="show">
    <v-card
      v-if="isResetPassword"
      width="60vw"
      class="ma-10 card_shadow mx-auto"
    >
      <v-form ref="form">
        <v-container class="pt-5">
          <v-row :class="['headline', { 'headline-rounded': isResetPassword }, 'mt-n5']">
            <v-col class="active_text">
              <p>
                {{
                     $t('signIn.resetPassword')
                }}
              </p>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="mt-10" cols="10">
              <input-new-pass
                ref="inputNewPass"
                :isSecurity="true"
                @setPassword="setPassword"
                @validatePassword="disableBtn"
                @keydown.native.enter.prevent="onSubmit"
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-n7">
            <v-col cols="10">
              <p
                v-html="$t('securitySettings.passwordCriteriaDescription')"
              ></p>
            </v-col>
          </v-row>
          <v-row v-if="isSamePasswordError" justify="center" class="mb-n7">
            <v-col cols="10">
              <v-alert icon="mdi-alert-circle" type="error">
                {{ $t('securitySettings.samePasswordError') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="errorMessage" justify="center" class="mb-n7">
            <v-col cols="10">
              <v-alert icon="mdi-alert-circle" type="error">
                {{ errorMessage }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row justify="center" class="ma-5">
            <v-btn
              :disabled="isDisable"
              color="#1b2643"
              @click="onSubmit"
              class="white--text btn_shadow"
            >
              {{ $t('securitySettings.change') }}
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    <div v-else>
    <div class="headline pa-3">
              <p class="active_text">
                {{
                    $t('securitySettings.securitySetting')
                }}
              </p>
          </div>
      <v-form ref="form">
        <div class="px-10 content">
          <v-row v-if="userAuth?.email" class="mt-15">
            <v-col cols="10">
              <v-text-field
                :value="userAuth?.email"
                :label="$t('common.email')"
                persistent-placeholder
                outlined
                readonly
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mt-0" cols="10">
              <input-new-pass
                ref="inputNewPass"
                :isSecurity="true"
                @setPassword="setPassword"
                @validatePassword="disableBtn"
                @keydown.native.enter.prevent="onSubmit"
              />
            </v-col>
          </v-row>
          <v-row class="mt-n7">
            <v-col cols="10">
              <p
                v-html="$t('securitySettings.passwordCriteriaDescription')"
              ></p>
            </v-col>
          </v-row>
          <v-row v-if="isSamePasswordError" class="mb-n7">
            <v-col cols="10">
              <v-alert icon="mdi-alert-circle" type="error">
                {{ $t('securitySettings.samePasswordError') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="errorMessage" class="mb-n7">
            <v-col cols="10">
              <v-alert icon="mdi-alert-circle" type="error">
                {{ errorMessage }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row justify="center" class="ma-5">
            <v-btn
              :disabled="isDisable"
              color="#1b2643"
              @click="onSubmit"
              class="white--text btn_shadow"
            >
              {{ $t('securitySettings.change') }}
            </v-btn>
          </v-row>
        </div>
      </v-form>
    </div>
    </div>
    <v-dialog v-model="showConfirmDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          {{ $t('securitySettings.confirmDialog.title') }}
        </v-card-title>
        <v-card-text>
          <v-alert type="info" color="#1b2643" dense class="mt-2">
            {{ $t('securitySettings.confirmDialog.warning') }}
          </v-alert>
          <p class="mt-4">
            {{ $t('securitySettings.confirmDialog.copyReminder') }}
          </p>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn text @click="showConfirmDialog = false">
            {{ $t('securitySettings.confirmDialog.cancel') }}
          </v-btn>
          <v-btn
            color="#1b2643"
            class="white--text"
            @click="confirmPasswordChange"
          >
            {{ $t('securitySettings.confirmDialog.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar
      :snackbarAction="isSnackbarAction"
      :snackbarText="String($t('securitySettings.passwordChangedMessage'))"
      snackbarColor="primary"
      @closeSnackbar="closeSnackbar"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { confirmPasswordReset, getAuth, updatePassword } from "firebase/auth";
import InputNewPass from "@/components/Dashboard/PageViewItems/InputNewPasswordField.vue";
import SnackBar from "@/components/Dashboard/PageViewItems/SnackbarComponent.vue";
import type { UserAuthInfo } from "@/resources/userAuthInfo";

export default defineComponent({
  name: "ChangePasswordForm",
  props: {
    show: Boolean,
    userAuth: {
      type: Object as () => UserAuthInfo,
    },
    oobCode: String,
  },
  components: {
    InputNewPass,
    SnackBar,
  },
  computed: {
    isResetPassword(): boolean {
      return this.$route.path === "/reset-password";
    },
  },
  data() {
    return {
      password: "",
      isDisable: true,
      isSamePasswordError: false,
      showConfirmDialog: false,
      isSnackbarAction: false,
      errorMessage: "",
    };
  },
  methods: {
    onSubmit() {
      this.errorMessage = "";
      if (this.isResetPassword) {
        this.resetPassword();
        return;
      }
      if (!this.userAuth?.user || !this.userAuth?.password) {
        return;
      }
      if (this.password === this.userAuth.password) {
        this.isSamePasswordError = true;
        return;
      }
      this.isSamePasswordError = false;
      this.showConfirmDialog = true;
    },
    async confirmPasswordChange() {
      if (!this.userAuth?.user) {
        return;
      }
      try {
        await updatePassword(this.userAuth.user, this.password);
        this.showConfirmDialog = false;
        this.isSnackbarAction = true;
        this.password = "";
        this.$emit("update:show", false);
        const inputNewPass = this.$refs.inputNewPass as InstanceType<
          typeof InputNewPass
        >;
        if (inputNewPass) inputNewPass.reset();
      } catch (error) {
        console.error("[Security] Password update failed:", error);
        this.showConfirmDialog = false;
        const code = (error as { code: string }).code;
        if (code === "auth/requires-recent-login") {
          this.errorMessage = String(
            this.$t("securitySettings.sessionExpiredReauth"),
          );
        } else {
          this.errorMessage = String(
            this.$t("securitySettings.passwordChangeFailed"),
          );
        }
      }
    },
    async resetPassword() {
      if (!this.oobCode) {
        return;
      }
      try {
        await confirmPasswordReset(getAuth(), this.oobCode, this.password);
        this.password = "";
        this.$emit("update:show", false);
        const inputNewPass = this.$refs.inputNewPass as InstanceType<
          typeof InputNewPass
        >;
        if (inputNewPass) inputNewPass.reset();
        this.$router.push({
          name: "Sign In",
          params: {
            snackbarAction: "true",
            snackbarText: String(this.$t("signIn.passwordReset")),
            snackbarColor: "pink",
          },
        });
      } catch (error) {
        console.error("[Security] Password reset failed:", error);
        this.errorMessage = String(
          this.$t("securitySettings.passwordChangeFailed"),
        );
      }
    },
    setPassword(pass: string) {
      this.isSamePasswordError = false;
      this.password = pass;
    },
    disableBtn(isDisable: boolean) {
      this.isDisable = isDisable;
    },
    closeSnackbar() {
      this.isSnackbarAction = false;
    },
  },
});
</script>
